import { Doc } from 'src/@types/docs';
import { PageHeaderContainer } from 'src/components/PageHeader/PageHeaderContainer';
import DocsBreadcrumbs from './DocsBreadcrumbs';
import { HeaderActions } from './HeaderActions';

type Props = {
  doc: Doc;
  handlePrint: () => void;
};

export function Header({ doc, handlePrint }: Props) {
  return (
    <PageHeaderContainer>
      <DocsBreadcrumbs
        sx={{ mb: '0', width: '100%' }}
        doc={doc}
        action={<HeaderActions doc={doc} handlePrint={handlePrint} />}
      />
    </PageHeaderContainer>
  );
}
